export default __webpack_public_path__ + "static/media/XMARK-BUSD.c357b1df.svg";